import { useState, FormEvent, useContext, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { licencasGesttor } from '../../services/organizacao'
import { ModalOrganizacaoDados } from '../../interfaces/organizacao'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { Button, Loader } from '../Styles'
import { RiCustomerService2Fill, RiDraftFill } from "react-icons/ri"
import { toast } from 'react-toastify'
import { criptografarDado, descriptografarDado } from '../../helpers'
import { atualizarModulo, buscarModulos } from '../../services/modulos'
import { listaModulo } from '../../interfaces/modulos'
import { MdOutlineFindInPage } from 'react-icons/md'
import { IoDocumentOutline } from 'react-icons/io5'
import { atualizarUsuario } from '../../services/usuarios'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import licencaImg from '../../assets/img/licenca.png'
import ModalNovoModulo from '../ModalNovoModulo'
import DivSituacao from '../DivSituacao'
import '../../styles/modal.css'
import './index.css'

function ModalGerenciarLicenca({ organizacao }: ModalOrganizacaoDados) {

    const { modal, modalExibir, exibirModal, atualizarDados } = useContext(ModalEstadoContext)

    const navigate = useNavigate()
    const location = useLocation()
    const { pathname, search } = location

    const [usuariosAdicionais, setUsuariosAdicionais] = useState<number>(organizacao?.usuariosAdicionais ?? 0)
    const [conexoesAdicionais, setConexoesAdicionais] = useState<number>(organizacao?.conexoesAdicionais ?? 0)
    const [validadeLicenca, setValidadeLicenca] = useState<string | undefined>(organizacao?.validadeLicenca)
    const [cidadesAtendidas, setCidadesAtendidas] = useState<number>(organizacao?.cidadesAtendidas ?? 3)
    const [palavrasChaves, setPalavrasChaves] = useState<number>(organizacao?.palavrasChaves ?? 5)
    const [modulos, setModulos] = useState<listaModulo[]>([])
    const [saldoDoc, setSaldoDoc] = useState<number>()
    const [processando, setProcessando] = useState(false)

    const toggleUsuario = async (usuario: usuariosRespostaPayload, tipo: string) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_licenca']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para atualizar dados de uma licença.")
        let payload: any = {};

        try {
            if (tipo === "gesttor") {
                payload = {
                    perfil: usuario.perfil,
                    usuarioGesttor: !usuario.usuarioGesttor
                };
            } else if (tipo === "projeto") {
                payload = {
                    perfil: usuario.perfil,
                    usuarioProjeto: !usuario.usuarioProjeto
                };
            } else if (tipo === "zai") {
                payload = {
                    perfil: usuario.perfil,
                    usuarioZai: !usuario.usuarioZai
                };
            }

            const resposta = await atualizarUsuario(usuario.id, payload)

            if (resposta.status === 200) {
                atualizarDados()
                return toast.success("Dados do Usuário atualizados com Sucesso.")
            }

        } catch (error: any) {
            if (error.response.status === 408) {
                return toast.error("Limite de Usuários Ativos do Plano Atingido.")
            }

            toast.error("Ocorreu um erro ao tentar atualizar os dados do usuário, favor tente novamente!")
        }
    }

    function ocultarModal() {

        navigate(pathname)
        exibirModal()
    }

    const atualizarLicencas = async (e: FormEvent) => {

        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_licenca']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para atualizar dados de uma licença.")
        setProcessando(true)

        const parms = new URLSearchParams(search)
        const id = parms.get('idCliente')

        if (validadeLicenca == null || validadeLicenca === undefined || id === null || usuariosAdicionais === undefined) {
            return setProcessando(false)
        }

        const payload = {
            validadeLicenca,
            usuariosAdicionais,
            conexoesAdicionais,
            cidadesAtendidas,
            palavrasChaves
        }

        try {

            const resposta = await licencasGesttor(id, payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success("Dados atualizados com sucesso.")
                atualizarDados()

                return
            }

        } catch (error: any) {

            setProcessando(false)

            return toast.error("Ocorreu um erro ao tentar salvar os dados!")

        }
    }

    const bloquearModulo = async (moduloSelecionado: listaModulo) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_licenca']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para bloquear o modulo de uma licença.")
        setProcessando(true)
        if (!moduloSelecionado) return toast.error("Não foi possivel Encontrar o Módulo que Deseja Bloquear")
        const idModuloCript = criptografarDado(moduloSelecionado.id.toString())
        try {
            const payload = {
                situacao: "Inativo"
            }

            await atualizarModulo(idModuloCript, payload)
            setProcessando(false)
            atualizarDados()
            modalExibir("")
            return toast.success("Módulo Bloqueado com Sucesso.")
        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao tentar Bloquear Módulo")
        }
    }

    const ativarModulo = async (moduloSelecionado: listaModulo) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_licenca']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para ativar o modulo de uma licença.")
        setProcessando(true)
        if (!moduloSelecionado) return toast.error("Não foi possivel Encontrar o Módulo que Deseja Ativar")
        const idModuloCript = criptografarDado(moduloSelecionado.id.toString())
        try {
            const payload = {
                situacao: "Ativo"
            }

            await atualizarModulo(idModuloCript, payload)
            setProcessando(false)
            atualizarDados()
            modalExibir("")
            return toast.success("Módulo Ativado com Sucesso.")
        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao tentar Ativar Módulo")
        }
    }

    const atualizarSaldoModulo = async (moduloSelecionado: listaModulo) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'gesttor_licenca']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para atualizar o saldo do modulo.")
        setProcessando(true)

        if (!moduloSelecionado) return toast.error("Não foi possivel Encontrar o Módulo para Atualizar o Saldo")
        if (moduloSelecionado.situacao === "Inativo") {
            toast.info("O Modulo precisa estar ativo para Atualizar o Saldo")
            return setProcessando(false)
        }
        if (!saldoDoc) {
            toast.info("Digite um valor para Atualizar o Saldo")
            return setProcessando(false)
        }
        const idModuloCript = criptografarDado(moduloSelecionado.id.toString())

        try {
            const payload = {
                saldoDoc
            }

            await atualizarModulo(idModuloCript, payload)
            setProcessando(false)
            atualizarDados()
            modalExibir("")
            return toast.success("Saldo Atualizado com Sucesso.")
        } catch (error: any) {
            if (saldoDoc !== undefined && saldoDoc < 0) {
                setProcessando(false)
                return toast.info("O Saldo não pode ser Negativo")
            }
            setProcessando(false)
            return toast.error("Erro ao tentar Atualizar Saldo")
        }
    }

    useEffect(() => {
        const listarModulosOrganizacao = async () => {

            const parms = new URLSearchParams(search)
            const idOrganizacao = parms.get('idCliente')
            if (!idOrganizacao) return

            try {

                const resposta = await buscarModulos(idOrganizacao)

                return setModulos(resposta.data)

            } catch (error) {
                return toast.error("Erro ao tentar listar os Modulos da Organização")
            }
        }
        listarModulosOrganizacao()

    }, [atualizarDados, search])

    return (
        <div id='fundoModal'>
            {modal.nome === "ModalNovoModulo" && <ModalNovoModulo />}
            <section id='containerModalNovo'>
                <span id='novoContainerTitulo'>
                    <img id='adicionarModalIcone' src={licencaImg} alt='' />
                    <p>Gerenciar Licenças</p>
                </span>
                <form id='formModalNovo' onSubmit={atualizarLicencas}>
                    <section>
                        <span>
                            <label htmlFor="nomeFantasia">Nome Fantasia</label>
                            <input
                                id='nomeFantasia'
                                type="text"
                                value={organizacao?.nomeFantasia}
                                disabled />
                        </span>
                        <span>
                            <label htmlFor="razaoSocial">Razão Social</label>
                            <input
                                id='razaoSocial'
                                type="text"
                                value={organizacao?.razaoSocial === null ? '' : organizacao?.razaoSocial}
                                disabled />
                        </span>
                    </section>

                    <section className='novoContainerTitulo'>
                        <span>
                            <label htmlFor="usuariosAdicionais">Usuários Adicionais</label>
                            <input
                                id="usuariosAdicionais"
                                type="number"
                                min={0}
                                value={usuariosAdicionais === null ? 0 : usuariosAdicionais}
                                onChange={(e) => setUsuariosAdicionais(parseInt(e.target.value))}
                                required />
                        </span>
                        <span>
                            <label htmlFor="conexoesAdicionais">Conexões Adicionais</label>
                            <input
                                id="conexoesAdicionais"
                                type="number"
                                min={0}
                                value={conexoesAdicionais === null ? 0 : conexoesAdicionais}
                                onChange={(e) => setConexoesAdicionais(parseInt(e.target.value))}
                                required />
                        </span>
                        <span>
                            <label htmlFor="validadeLicenca">Validade da Licença</label>
                            <input
                                id="validadeLicenca"
                                type="date"
                                value={validadeLicenca}
                                onChange={(e) => setValidadeLicenca(e.target.value)}
                                required />
                        </span>
                    </section>
                    <section className='novoContainerTitulo'>
                        <span>
                            <label htmlFor="cidadesAtendidas">Cidades Atendidas</label>
                            <input
                                id="cidadesAtendidas"
                                type="number"
                                min={0}
                                value={cidadesAtendidas}
                                onChange={(e) => setCidadesAtendidas(parseInt(e.target.value))}
                                required />
                        </span>
                        <span>
                            <label htmlFor="palavrasChaves">Palavras Chaves</label>
                            <input
                                id="palavrasChaves"
                                type="number"
                                min={0}
                                value={palavrasChaves}
                                onChange={(e) => setPalavrasChaves(parseInt(e.target.value))}
                                required />
                        </span>
                    </section>
                    <label>Módulos da Organização</label>
                    {modulos && modulos.map((modulo) => (
                        <details id='container-gerenciar-modulos' key={modulo.id}>
                            <summary className='summary-gerenciar-modulos'>
                                <div className='header-modulo'>
                                    {modulo.nome === "Atendimento" && <RiCustomerService2Fill fontSize={"20px"} />}
                                    {modulo.nome === "Documentos" && <IoDocumentOutline fontSize={"20px"} />}
                                    {modulo.nome === "Recrutamento" && <MdOutlineFindInPage fontSize={"20px"} />}
                                    {modulo.nome === "Projetos" && <RiDraftFill fontSize={"20px"} />}
                                    <p>Módulo de {modulo.nome}</p>
                                </div>
                            </summary>
                            <section id='section-modulos'>
                                <div className='modulo-especifico'>
                                    <div className='situacao-modulo'>
                                        <DivSituacao texto={modulo.situacao} cor={modulo.situacao.toLowerCase()} />
                                        {modulo.nome === "Documentos" && <p>Saldo de documentos: <strong>{modulo.saldoDoc}</strong></p>}
                                    </div>
                                    <div>
                                        {modulo.situacao === "Ativo" && <Button type='button' cor='cancelar' isLoading={processando} onClick={(e: FormEvent) => bloquearModulo(modulo)}>Bloquear Módulo</Button>}
                                        {modulo.situacao === "Inativo" && <Button type='button' cor='salvar' isLoading={processando} onClick={(e: FormEvent) => ativarModulo(modulo)}>Liberar Módulo</Button>}
                                    </div>
                                </div>
                                {modulo.nome === "Documentos" && <div className='modulo-especifico'>
                                    <span>
                                        <input type="number" min={modulo.saldoDoc} placeholder='Novo Saldo de Documentos' onChange={(e) => setSaldoDoc(parseInt(e.target.value))} required />
                                    </span>
                                    <div>
                                        <Button type='button' cor='salvar' isLoading={processando} onClick={(e: FormEvent) => atualizarSaldoModulo(modulo)}>Atualizar Saldo</Button>
                                    </div>
                                </div>}
                            </section>
                        </details>
                    ))}
                    <section>
                        <span className='btn-novo-modulo'>
                            <Button type='button' cor='novo' isLoading={processando} onClick={() => modalExibir("ModalNovoModulo")}>Adicionar Novo Módulo</Button>
                        </span>
                    </section>
                    <details className='container-gerenciar'>
                        <summary className='summary-gerenciar-titulo'>
                            Gestão de Usuários
                        </summary>
                        <section id='section-usuarios'>
                            <table id='tabelaListaContainer'>
                                <thead>
                                    <tr>
                                        <th align='left'>Nome</th>
                                        <th align='left'>Perfil</th>
                                        <th>Situação</th>
                                        <th>Gesttor</th>
                                        <th>Projetos</th>
                                        <th>Zai</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {organizacao?.usuarios && organizacao.usuarios.map((usuario: any) => (
                                        <tr key={usuario.id}>
                                            <td id='primeiraColuna'>{usuario.nome}</td>
                                            <td align='left'>{usuario.perfil}</td>
                                            <td align='center'><DivSituacao texto={usuario.situacao} cor={usuario.situacao.toLowerCase()} /></td>
                                            <td>
                                                <div className="toggle-switch">
                                                    <input className="toggle-gerenciar-input" id={`toggle-usuario-gesttor-${usuario.id}`} type="checkbox" defaultChecked={usuario.usuarioGesttor} onChange={() => toggleUsuario(usuario, "gesttor")} />
                                                    <label className="toggle-label" htmlFor={`toggle-usuario-gesttor-${usuario.id}`}></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="toggle-switch">
                                                    <input className="toggle-gerenciar-input" id={`toggle-usuario-projeto-${usuario.id}`} type="checkbox" defaultChecked={usuario.usuarioProjeto} onChange={() => toggleUsuario(usuario, "projeto")} />
                                                    <label className="toggle-label" htmlFor={`toggle-usuario-projeto-${usuario.id}`}></label>
                                                </div>
                                            </td>
                                            <td id='ladoDireitoContent'>
                                                <div className="toggle-switch">
                                                    <input className="toggle-gerenciar-input" id={`toggle-usuario-zai-${usuario.id}`} type="checkbox" defaultChecked={usuario.usuarioZai} onChange={() => toggleUsuario(usuario, "zai")} />
                                                    <label className="toggle-label" htmlFor={`toggle-usuario-zai-${usuario.id}`}></label>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </section>
                    </details>

                    <details className='container-gerenciar'>
                        <summary className='summary-gerenciar-titulo'>
                            Gestão de Conexões
                        </summary>
                        <section id='section-usuarios'>
                            <table id='tabelaListaContainer'>
                                <thead>
                                    <tr>
                                        <th align='left'>Nome</th>
                                        <th align='left'>Tipo</th>
                                        <th align='center'>Situação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {organizacao?.conexoes && organizacao.conexoes.map((conexao: any) => (
                                        <tr key={conexao.id}>
                                            <td id='primeiraColuna'>{conexao.nome}</td>
                                            <td>{conexao.tipo}</td>
                                            <td align='center' id='ladoDireitoContent'><DivSituacao texto={conexao.situacao} cor={conexao.situacao.toLowerCase()} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </section>
                    </details>
                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={ocultarModal}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando} onClick={atualizarLicencas} disabled={processando}>
                            {!processando && 'Salvar Dados'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div >
    )
}

export default ModalGerenciarLicenca
